<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">Abstract Club Join</div>
    <div class="sopo-popup-text">Waiting to join to the Abstract Club...</div>
    <ion-spinner></ion-spinner>
    <div class="sopo-popup-text go-to-lobby" (click)="navigateToLobby()">Go to the Lobby</div>
</div>